import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
    state:{
        map:{},
        block:{},
        property:{},
        note:{},
        viewVersion:0,
        viewBlocks:false,
        viewProperties:true,
        // remember to update clearMaps mutation if you update this structure
    },
    mutations:{
        attribute(state, {id, attribute, value}){
            var type = id.split('-')[0];
            if (!state[type].hasOwnProperty(id)){
                var obj = {};
                obj[attribute] = value;
                state[type][id] = obj;
            }
            Vue.set(state[type][id],attribute, value);
            Vue.set(state[type][id],'updatedAt', Date.now());
        },
        feature(state, value){
            value.updatedAt = Date.now();
            Vue.set(state[value.type], value.id, value);
        },
        features(state, values){
            values.forEach((value)=>{
                value.updatedAt = Date.now();
                Vue.set(state[value.type], value.id, value);
            });
        },
        incView(state){
            state.viewVersion += 1
        },
        viewBlocks(state, val){
            state.viewBlocks = val;
        },
        viewProperties(state, val){
            state.viewProperties = val;
        },
        clearMaps(state){
            state.map={};
            state.block = {};
            state.property = {};
            state.note = {};
        },
        deselectInvisible(state){
            if (! state.viewProperties){
                Object.values(state.property).forEach(val=>{
                    Vue.set(val, 'selected', false);
                })
            }
            if (!state.viewBlocks) {
                Object.values(state.block).forEach(val=>{
                    Vue.set(val, 'selected', false);
                })
            }
            Object.values(state.map).forEach(val=>{
                Vue.set(val, 'selected', false);
            })
        },
        deleteFeature(state, id){
            var objType = id.split('-')[0];
            Vue.delete(state[objType], id);
        },
    },
    getters: {
        featureById: (state, getters) => (id) => {
            var type = id.split('-')[0];
            return state[type][id];
        },
        view: state => state.viewVersion,
        map: state => state.map,
        block: state => state.block,
        property: state => state.property,
        blockProperty: state => {return {...state.block, ...state.property};},
        allFeatures: state => {return {...state.map, ...state.block, ...state.property};},
        currentFeatures:(state,getters)=>{
            if (state.viewBlocks && state.viewProperties){
                return {...getters.blockProperty, ...state.note};
            } else if (state.viewProperties) {
                return {...state.property, ...state.note};
            } else if (state.viewBlocks) {
                return {...state.block, ...state.note};
            } else {
                return {};
            }
        },
        viewBlocks:state=>state.viewBlocks,
        viewProperties:state=>state.viewProperties,
        singleSelection:(state, getters) => {
            var selected = Object.values({...getters.allFeatures, ...state.note}).filter(val => val.selected);
            return selected.length == 1 ? selected[0] : {};
        },
        modifiedStructure:(state)=>{
            var retval = {property:[], block:[]};
            Object.values(state.block).forEach((val)=>{
                if (val.structureModified){
                    retval.block.push({
                        geometry:val.geometry.coordinates[0],
                        id:val.id.slice(val.type.length+1),
                        map_id:val.parent.slice('map-'.length),
                        sort_order:val.sort_order,
                    });
                }
             });
            Object.values(state.property).forEach((val)=>{
                if (val.structureModified){
                    retval.property.push({
                        geometry:val.geometry.coordinates[0],
                        id:val.id.slice(val.type.length+1),
                        block_id:val.parent.slice('block-'.length),
                    });
                }
             });
            return retval;
        },
        selectedDnc(state, getters){
            if (getters.singleSelection){
                return getters.singleSelection.do_not_call;
            }
            return null;
        },
        selectedId(sate, getters){
            return getters.singleSelection.id;
        },
        dncList(state){
            var dnc_list = [];
            Object.values(state.property).forEach((value)=>{
                if (value.do_not_call){
                    dnc_list.push({address:value.text, details:value.do_not_call.details})
                }
            });
            return dnc_list;
        },
        currentNotes(state){
            var notes = {};
            var vals = Object.entries(state.note);
            if (state.viewBlocks) {
                notes = Object.fromEntries(vals.filter(val => !val[1].block));
            }
            if (state.viewProperties) {
                notes = {...notes, ...Object.fromEntries(vals.filter(val => !!val[1].block))};
            }
            return notes;
        },
    }
})
